export default __webpack_public_path__ + "static/media/jackpot-cn.211e3244.webp";